export default __webpack_public_path__ + "img/TotalEnergies_logo.90d02131.svg";